<template>
  <van-popup v-model="mShow" @close="close">
    <div class="dialog column">
      <div class="t1" style="margin-top: 20px">提现明细</div>
      <div class="content" style="margin-top: 20px">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <van-row
              v-for="(item, index) in list"
              :key="index"
              style="margin-top: 12px"
            >
              <van-col span="2">
                <!-- <img class="avatar" style="margin-top: 10px;" src="../assets/cash_icon.png" alt="" /> -->
              </van-col>
              <van-col span="14" class="t3">
                <div class="column left">
                  <span>提现</span>
                  <span>{{ getStatusText(item.status) }}</span>
                  <span>{{ item.createTime }}</span>
                </div>
              </van-col>
              <van-col span="8" class="t4">
                <div style="margin-top: 10px">+{{ item.rmb }}元</div>
              </van-col>
            </van-row>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
    },
  },
  watch: {
    show(value) {
      this.mShow = value;
    },
  },

  data() {
    return {
      mShow: false,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    close() {
      this.mShow = false;
      this.$emit("close");
    },
    onLoad() {
      this.$request.GET({
        url: "agent/withdrawal/log",
        params: { isGroup: 1 },
        success: (obj) => {
          this.list = obj;
          this.finished = true;
          this.loading = false;
          this.refreshing = false;
        },
      });
    },
    
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },

    getStatusText(status) {
      let statusText = "";
      if (status === 0) {
        statusText = "审核中";
      } else if (status === 1) {
        statusText = "提现成功";
      } else if (status === 2) {
        statusText = "账号异常";
      } else if (status === 3) {
        statusText = "审核未通过";
      }
      return statusText;
    },
  },
};
</script>

<style scoped>
.dialog {
  width: 300px;
  height: 450px;
  background-image: url("../assets/dialogBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  font-weight: 600;
}

.content {
  overflow-y: scroll;
}

.column {
  display: flex;
  flex-direction: column;
}
.row {
  display: flex;
  flex-direction: row;
}
.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.avatar {
  width: 30px;
  height: 30px;
}
.center {
  justify-content: center;
}

.left {
  align-items: start;
}

.t1 {
  color: #f6cf97;
  font-size: 18sp;
  font-weight: 500;
}
.t2 {
  color: black;
  font-size: 12px;
}
.t3 {
  color: black;
  font-size: 12px;
}
.t4 {
  color: #36a732;
  font-size: 12px;
}
</style>